import React, { useState } from 'react';
import { Button, Nav } from 'react-bootstrap';
import {FaBars} from 'react-icons/fa';
import { Link, useNavigate } from "react-router-dom";
import {useDispatch } from 'react-redux';



import './CmsNavbar.css';

function CmsNavbar({action}) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [user,setUser]= useState(JSON.parse(localStorage.getItem('profile')));
    

    const logout = ()=>{
        dispatch({type: 'LOGOUT'});
        navigate('/');
        setUser(null)
    }

    return (
        <div>
            <Nav  className='NavWrapper'>
                <div className='logoWrapper'>
                    <Link to='/'>
                        <h3>SaiShreyas Residency</h3>
                    </Link>
                   
                   
                </div>
                {/* <div className='barsWrapper'>
                    <FaBars size='20px' className='fabars'  />
                </div> */}
                <div className='LogoutBtnWrapper' >
                    <FaBars size='20px' className='fabars' onClick={action}  />
                    <Button className='logoutBtn ' onClick={logout} >Logout</Button>
                </div>
            </Nav>
        </div>
    )
}

export default CmsNavbar
